<template>
  <div id="app" class="container-fluid">
    <div class="row main-row">
      <div class="col-3">
        <div class="card control-left">
          <div class="card-header">Options</div>
          <div class="card-body">
            <div class="form-horizontal">

              <div class="form-group">
                <label for="classifScheme" class="control-label">Classification</label>
                <select id="classifScheme" class="form-control" v-model="classifScheme">
                  <option v-for="classif in classifications" :key="classif.name" :value="classif.name">{{ classif.name }}</option>
                </select>
              </div>

              <div class="form-group">
                <label for="minAngleDisplayed">Minimal arc angle to be displayed</label>
                <div>
                  <input id="minAngleDisplayed" class="form-control" type="range" min="0" step="0.001" max="0.1" v-model.number="minAngleDisplayed">
                </div>
                <div>
                  <p>{{ minAngleDisplayed }} radian</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="col-9">
        <div class="card control-left">
          <div class="card-header">Sequence of events (Sunburst) {{ classifScheme }}</div>
          <div class="card-body father">
            <sunburst class="sunburst" :data="data" :minAngleDisplayed="minAngleDisplayed" :colorScheme="colorScheme" :colorScale="colorScale" :inAnimationDuration="inAnimationDuration" :outAnimationDuration="outAnimationDuration">

              <breadcrumbTrail slot="legend" slot-scope="{ nodes, colorGetter, width }" :current="nodes.mouseOver" :root="nodes.root" :colorGetter="colorGetter" :from="nodes.zoomed" :width="width" :item-width="500" :item-height="20"/>

              <nodeInfoDisplayer slot="top" slot-scope="{ nodes }" :current="nodes.mouseOver" :root="nodes.root" :clicked="nodes.clicked" description="of selected" />

              <template slot-scope="{ on, actions }">
                <highlightOnHover v-bind="{ on, actions }" />
                <zoomOnClick v-bind="{ on, actions }" />
              </template>
            </sunburst>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import sunburst from "@/components/sunburst";
import sankey from "@/components/sankey";
import nodeInfoDisplayer from "@/components/nodeInfoDisplayer";
import breadcrumbTrail from "@/components/breadcrumbTrail";
//behaviours
import highlightOnHover from "@/components/behavior/highlightOnHover";
import zoomOnClick from "@/components/behavior/zoomOnClick";

import { colorSchemes } from "@/infra/colorSchemes";
import { scaleOrdinal } from "d3-scale";

const colorSchemesNames = Object.keys(colorSchemes).map(key => ({
  value: key,
  text: colorSchemes[key].name
}));

import fullData from "../data/sunburst";
import allParameters from "../data/allparameters";


export default {
  name: "app",
  data() {
    return {
      colorScheme: colorSchemesNames[0].value,
      colorSchemes: colorSchemesNames,
      classifications: allParameters["classif"],
      classifScheme: allParameters["classif"][0].name,
      minAngleDisplayed: 0.00,
      inAnimationDuration: 100,
      outAnimationDuration: 1000,
      overrideColorScale: false
    };
  },
  computed:{
    colorScale(){
      return this.overrideColorScale ? this.custoColorScale : null;
    },
    data() {
       return fullData[this.classifScheme]["data"]
    }
  },
  components: {
    sunburst,
    nodeInfoDisplayer,
    breadcrumbTrail,
    highlightOnHover,
    zoomOnClick
  }
};
</script>

<style lang="less">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;

  height: 800px;

  .main-row {
    height: 800px;
  }

  .control-left {
    height: 100%;
  }

  .resizable {
    margin-left: calc(50% - 50px);
  }

  .father {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
  }

  .sunburst {
    width: 100%;
    height: 100%;
    position: relative;
  }

  .custo-checkbox {
    display: flex;
    justify-content: space-between;
  }
}
</style>
